import { useEffect, useMemo } from "react";
import { Logger } from "@/lib/logger";
import { isOwnAppWebView } from "@/lib/device";

const log = new Logger("WebView");

export function useDetectWebView() {
  const isWebView = useMemo(() => isOwnAppWebView(), []);

  useEffect(() => {
    log.debug("UserAgent:", navigator.userAgent);
    log.debug("isWebView:", isWebView);
  }, [isWebView]);

  return isWebView;
}
